import { ArrowRight } from 'lucide-react';

import { ButtonLink, Container } from '../ui';

export function FinalCta() {
  return (
    <section aria-labelledby="cta-title" className="pb-24 md:pb-32">
      <Container>
        <div className="rounded-panel bg-ink px-8 py-14 text-center md:px-16 md:py-20">
          <h2
            className="mx-auto max-w-2xl text-balance font-report text-report-section font-medium text-white"
            id="cta-title"
          >
            Find out where you stand — before your users do.
          </h2>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <ButtonLink to="/request" variant="inverse">
              Request an audit <ArrowRight aria-hidden size={18} />
            </ButtonLink>
          </div>
        </div>
      </Container>
    </section>
  );
}
